import * as React from 'react';
import { useParams } from 'react-router-dom';
import { Center, Flex } from '@chakra-ui/react';
import { useAppSelector, useGetCatByIdQuery } from '@spartalabs/pdc-core';
import { Container, EmptyCard, ErrorCard } from 'components';
import { CardSkele } from 'components/Skeletons/Card';
import { FaQSearch } from '../components/Search';
import { QuestionCard } from './components/QuestionCard';

export const QuestionList: React.FC = () => {
  const { id } = useParams();

  const permissions = useAppSelector(
    state => state.authSlicer.user.permissions,
  );

  const { data, isLoading, isError, refetch } = useGetCatByIdQuery({
    id: id || '',
  });

  return (
    <Container bg="white">
      <FaQSearch
        direction={-1}
        title={data?.title}
        desc={data?.desc}
        canEdit={permissions?.includes('faq')}
      />

      {isError ? (
        <ErrorCard border="0px" boxShadow="0px" refetch={refetch} />
      ) : !isLoading && !data?.FAQs?.length ? (
        <EmptyCard
          backTo="/centraldeduvidas"
          mt="40px"
          border="0px"
          boxShadow="0px"
        />
      ) : (
        <Center flexDir="column">
          <Flex
            justifyContent={{ lg: 'start', base: 'center' }}
            wrap="wrap"
            w={{ md: '82%', base: '100%' }}
            pb="24px"
            px="18px"
            gap="24px"
            mt="32px"
          >
            {!isLoading &&
              data?.FAQs.map(faq => (
                <QuestionCard
                  id={faq.id}
                  key={faq.id}
                  title={faq.title}
                  description={faq.desc}
                />
              ))}

            {isLoading &&
              [0, 1, 2, 3, 4, 5].map(fakeNatty => (
                <CardSkele
                  key={fakeNatty}
                  minW={0}
                  h="208px"
                  w={{ base: '100%', md: '368px' }}
                >
                  <></>
                </CardSkele>
              ))}
          </Flex>
        </Center>
      )}
    </Container>
  );
};
